'use strict';

export default {
    /**
     * Rename a saved basket
     * @param {string} name
     * @param {string} id
     */
    rename(name, id) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'PUT',
                url: '/api/baskets/saved/' + id,
                headers: {
                    'Accept': 'application/json'
                },
                data: {
                    name: name
                }
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Services/SavedBasket.js